import { Injectable } from "@angular/core";
import ScrollTrigger, { Trigger } from "@terwanerik/scrolltrigger";
import { from, Observable, Observer, Subject } from "rxjs";

export type ScrollDirection =
  | 'top'
  | 'right'
  | 'bottom'
  | 'left';


@Injectable({
  providedIn: 'root'
})
export class ScrollTriggerService {

  public scrollTrigger: ScrollTrigger;

  private _directionChange: Subject<ScrollDirection>;
  private _callback: Subject<{ position: { x: number, y: number }, direction: ScrollDirection }>;

  public directionChange$: Observable<ScrollDirection>;
  public callback$: Observable<{ position: { x: number, y: number }, direction: ScrollDirection }>;

  constructor () {
    this._directionChange = new Subject();
    this._callback = new Subject();

    this.directionChange$ = from( this._directionChange );
    this.callback$ = from( this._callback );

    this.scrollTrigger = new ScrollTrigger({
      scroll: {
        element: window,
        sustain: 100,
        callback: ( position, direction ) => {
          this._callback.next({ position, direction });
        },
        directionChange: ( dir ) => {
          this._directionChange.next( dir );
        }
      }
    });
  }
}
